import React from 'react';
import { GlobalHotKeys } from 'react-hotkeys';
import { TerrainBlock } from './TerrainBlock';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { IconButton } from '@chakra-ui/react';

const step = {
  x: 16,
  y: 9,
};

class Terrain extends React.Component {
  isMoveAvailable = (where) => {
    const { position } = this.props.redux.terrain,
      { size } = this.props.redux.planet;
    switch (where) {
      case 'left':
        return position.x - step.x >= 0;
      case 'right':
        return position.x + step.x < size.height;
      case 'up':
        return position.y - step.y >= 0;
      case 'down':
        return position.y + step.y < size.width;
      default:
        return false;
    }
  };

  handleMove = (position) => (event) => {
    event.preventDefault();
    const { terrain, planet } = this.props.redux;
    if (this.isMoveAvailable(position)) {
      switch (position) {
        case 'left':
          terrain.position = {
            ...terrain.position,
            x: terrain.position.x - step.x,
          };
          this.props.redux.updatePlanetAction(planet, terrain.position);
          this.props.redux.updateTerrainAction(terrain, planet);
          break;
        case 'right':
          terrain.position = {
            ...terrain.position,
            x: terrain.position.x + step.x,
          };
          this.props.redux.updatePlanetAction(planet, terrain.position);
          this.props.redux.updateTerrainAction(terrain, planet);
          break;
        case 'up':
          terrain.position = {
            ...terrain.position,
            y: terrain.position.y - step.y,
          };
          this.props.redux.updatePlanetAction(planet, terrain.position);
          this.props.redux.updateTerrainAction(terrain, planet);
          break;
        case 'down':
          terrain.position = {
            ...terrain.position,
            y: terrain.position.y + step.y,
          };
          this.props.redux.updatePlanetAction(planet, terrain.position);
          this.props.redux.updateTerrainAction(terrain, planet);
          break;
        default:
          console.log("Something's wrong!");
          break;
      }
    }
  };

  render() {
    const { data } = this.props;
    const { redux } = this.props;
    let terrainTemplate;
    terrainTemplate = redux.terrain.map.map(
      function (item) {
        return (
          <TerrainBlock
            key={item.id}
            data={item}
            prevProps={data}
            redux={this.props.redux}
            width={window.innerWidth / 16}
            height={window.innerHeight / 9}
          />
        );
      }.bind(this)
    );

    let style = {
      filter: 'hue-rotate(' + redux.planet.hue + 'deg)',
    };

    const keyMap = {
      MOVE_UP: ['w', 'up'],
      MOVE_DOWN: ['s', 'down'],
      MOVE_LEFT: ['a', 'left'],
      MOVE_RIGHT: ['d', 'right'],
    };
    const handlers = {
      MOVE_UP: this.handleMove('up'),
      MOVE_DOWN: this.handleMove('down'),
      MOVE_LEFT: this.handleMove('left'),
      MOVE_RIGHT: this.handleMove('right'),
    };

    // settings.SCALE_MODE = SCALE_MODES.NEAREST;

    return (
      <React.Fragment>
        <GlobalHotKeys keyMap={keyMap} handlers={handlers} />
        <IconButton
          className="terrain__move terrain__move-left"
          variant="ghost"
          position="absolute"
          top="50%"
          onClick={this.handleMove('left')}
          disabled={!this.isMoveAvailable('left')}
        >
          <KeyboardArrowLeftIcon />
        </IconButton>
        <IconButton
          className="terrain__move terrain__move-right"
          variant="ghost"
          position="absolute"
          top="50%"
          right="0"
          onClick={this.handleMove('right')}
          disabled={!this.isMoveAvailable('right')}
        >
          <KeyboardArrowRightIcon />
        </IconButton>
        <IconButton
          className="terrain__move terrain__move-up"
          variant="ghost"
          position="absolute"
          left="50%"
          onClick={this.handleMove('up')}
          disabled={!this.isMoveAvailable('up')}
        >
          <KeyboardArrowUpIcon />
        </IconButton>
        <IconButton
          className="terrain__move terrain__move-down"
          variant="ghost"
          position="absolute"
          left="50%"
          bottom="0"
          onClick={this.handleMove('down')}
          disabled={!this.isMoveAvailable('down')}
        >
          <KeyboardArrowDownIcon />
        </IconButton>
        <div className="terrain" style={style}>
          {terrainTemplate}
          {/*<Stage options={{
                        width: window.innerWidth,
                        height: window.innerHeight
                    }}></Stage>*/}
        </div>
      </React.Fragment>
    );
  }
}

export { Terrain };
